import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { LIST_BY_RUBRICS } from 'src/constants/routes';
import { IRubricResultModel } from 'src/interfaces/news';
import { createLinkProps } from 'src/utils/routing';

import { Typography } from '@sravni/react-design-system';

import styles from './item.module.scss';

interface Props {
  item: IRubricResultModel;
  closeView: () => void;
}

export const Item = ({ item, closeView }: Props) => {
  const {
    query: { rubric, rubricAlias },
  } = useRouter();

  const { href, as } = createLinkProps('list', LIST_BY_RUBRICS, {
    rubric: item.alias,
  });
  const isActive = item.alias === rubric || item.alias === rubricAlias;

  return (
    <Typography.Text
      size={14}
      strong
      className={classNames(styles.item, 'h-mt-24')}
      key={`rubric-${item.alias}`}
      onClick={closeView}
    >
      <Link href={href} as={as}>
        <Typography.Link
          href={as}
          color={'dark'}
          className={classNames(styles.itemLink, { [styles[`itemLink--active`]]: isActive })}
        >
          {item.iconUrl && (
            <img width={36} height={36} src={item.iconUrl} className={styles.itemIcon} alt={'Иконка рубрики'} />
          )}
          {item.name}
        </Typography.Link>
      </Link>
    </Typography.Text>
  );
};
